import receptor from '../../store/modules/receptor/redirect';
<template lang="pug">
div.margin-negativo
  el-row.padding.cards-sicarf
    el-col.margin-bottom-container(:md="8" :sm="24")
      div(:class="isIcmBio ? 'coluna-externa-icmbio' : 'coluna-externa'")
        div.coluna-interna
          div.quadrante-1
            //- TODO: Mapear imagens corretamente quando houver tempo
            img.como-fazer-seu-cadastro(:src="require(isIcmBio ? '@/assets/images/logo-icmBio2.png' : '@/assets/icons/Cadastro.png')" :style="{height: isIcmBio ? '120px': '', width: isIcmBio ? 'auto' : '5.5em'}")
            h1.primeiro-titulo-preto {{ HOME_PAGE.TITULO_CADASTRO }}
          div.quadrante-2.padding-top-tipo-cadastro(v-html="HOME_PAGE.TEXTO_CADASTRO", @click="handleTextoCadastro" :style="{'border-bottom': !HOME_PAGE.EXIBIR_APTIDAO ? 'none' : '1.8px dashed #009d64'}")
          div.quadrante-3.padding-top-link-baixar-enviar(v-if="HOME_PAGE.EXIBIR_APTIDAO")
            <a href="https://sicarf.amapaterras.ap.gov.br/documentos-estatico/AUTO_DECLARACAO_DE_APTIDAO_A_REGULARIZACAO_FUNDIARIA.pdf">
            el-span.links.botao-aptidao
              span APTIDÃO
              font-awesome-icon.icone-colunas(icon="cloud-download-alt")
            </a>
          div.quadrante-4.padding-top-link-baixar-enviar(v-if="HOME_PAGE.EXIBIR_APTIDAO")
              <a href="https://sicarf.amapaterras.ap.gov.br/documentos-estatico/DECLARACAO_DE_RESIDENCIA_AP.pdf">
                el-span.links.botao-aptidao
                  span RESIDÊNCIA
                  font-awesome-icon.icone-colunas(icon="cloud-download-alt")
              </a>
    el-col.margin-bottom-container(:md="8" :sm="24")
      div(:class="isIcmBio ? 'coluna-externa-icmbio' : 'coluna-externa'")
        div.coluna-interna
          div.quadrante-1
            //- TODO: Mapear imagens corretamente quando houver tempo
            img.como-fazer-seu-cadastro(:src="require(isIcmBio ? '@/assets/images/planta-icmBio.png' : '@/assets/icons/OFF.png')" :style="{height: isIcmBio ? '120px': '', width: isIcmBio ? 'auto' : '5.5em'}")
            h1.primeiro-titulo-segunda-coluna.primeiro-titulo-preto {{ HOME_PAGE.TITULO_CADASTRO_OFF }}
            h1(v-if="HOME_PAGE.SUBTITULO_CADASTRO_OFF").segundo-titulo-segunda-coluna {{ HOME_PAGE.SUBTITULO_CADASTRO_OFF }}
          div.quadrante-2.padding-top-tipo-cadastro(:style="{'border-bottom': (!EXIBIR_COMO_BAIXAR && !EXIBIR_COMO_ENVIAR) ? 'none' : '1.8px dashed #009d64'}")
            div(v-for="cadastros in HOME_PAGE.CADASTROS_OFFLINE")
              div(v-if="!cadastros.NEED_BREAK")
                el-tooltip(v-if="cadastros.TOLLTIP", :content='cadastros.TOLLTIP', placement='bottom')
                  span(v-html="cadastros.SPAN")
                p.line-height(v-else-if="cadastros.SPAN" v-html="cadastros.SPAN")
                p.item-tipo-cadastro(v-if="cadastros.TEXTO", v-html="cadastros.TEXTO")
              div(v-if="cadastros.NEED_BREAK")
                el-tooltip(v-if="cadastros.TOLLTIP")
                  div(slot="content") {{ cadastros.TOLLTIP_PART_1 }}
                  div(slot="content") {{ cadastros.TOLLTIP_PART_2 }}
                  span(v-html="cadastros.SPAN")
                p.line-height(v-else-if="cadastros.SPAN" v-html="cadastros.SPAN")
                p.item-tipo-cadastro(v-if="cadastros.TEXTO", v-html="cadastros.TEXTO")

          div.quadrante-3.padding-top-link-baixar-enviar(v-if="EXIBIR_COMO_BAIXAR")
            a.links(href="#/publico/baixar")
              span BAIXAR
              font-awesome-icon.icone-colunas(icon="cloud-download-alt")
          div.quadrante-4.padding-top-link-baixar-enviar(v-if="EXIBIR_COMO_ENVIAR")
            a.links(href="#/publico/enviar")
              span ENVIAR
              font-awesome-icon.icone-colunas(icon="cloud-upload-alt")
    el-col.margin-bottom-container(:md="8" :sm="24" v-if="EXIBIR_CADASTRO_ONLINE")
      div(:class="isIcmBio ? 'coluna-externa-icmbio' : 'coluna-externa'")
        div.coluna-interna
          div.quadrante-1
            //- TODO: Mapear imagens corretamente quando houver tempo
            img.como-fazer-seu-cadastro(:src="require(isIcmBio ? '@/assets/images/logo2.png' : '@/assets/icons/ON.png')" :style="{height: isIcmBio ? '120px': '', width: isIcmBio ? 'auto' : '5.5em'}")
            h1.primeiro-titulo-segunda-coluna.primeiro-titulo-preto {{ HOME_PAGE.TITULO_CADASTRO_ON }}
            h1(v-if="HOME_PAGE.SUBTITULO_CADASTRO_ON").segundo-titulo-segunda-coluna {{ HOME_PAGE.SUBTITULO_CADASTRO_ON }}
          div.quadrante-5.padding-top-tipo-cadastro(:style="{'border-bottom': (!EXIBIR_ACESSAR_ONLINE) ? 'none' : '1.8px dashed #009d64'}")
            div(v-for="cadastros in HOME_PAGE.CADASTROS_ONLINE")
              el-tooltip(v-if="cadastros.TOLLTIP", :content='cadastros.TOLLTIP', placement='bottom')
              p(v-html="cadastros.SPAN")

          div.padding-top-link-acesse(v-if="EXIBIR_ACESSAR_ONLINE")
            a.links(href="#/publico/central")
              span ACESSE
              font-awesome-icon.icone-colunas(icon="external-link-alt")

  el-row.sicarf
    el-row
      el-col(:md="24" :sm="24")
        div.text-sicarf
          div.cabecalho
            h1.titulo-sicarf {{ HOME_PAGE.O_SICARF_TITULO }}
            img.redimensiona(src="~@/assets/images/linha.png")
    el-row.sicarf.margin-bottom-container
      el-col.sicarf-col(:md="12" :sm="24").text-sicarf
          p(v-html="HOME_PAGE.O_SICARF")
          p.descricaoSicarf(v-html="HOME_PAGE.O_SICARF_DESCRICAO")
      el-col.sicarf-col.frame(:md="12" :sm="24")
        img.image-sicarf(:src="HOME_PAGE.O_SICARF_DESCRICAO_IMG")

  el-row.row-center.margin-bottom-container
    div.padding-titulo(v-if="HOME_PAGE.COMO_FUNCIONA")
      h1.titulo-sicarf Veja como funciona!
      img.redimensiona(src="~@/assets/images/linha.png")

    div(v-if="VIDEOS_TUTORIAIS")
      .video-container.center
        .video-content
          iframe.default-iframe(showinfo="0" width="90%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.APRESENTACAO" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")
          .video-span Conheça o SiCARF

      .video-container
        .video-content
          iframe.default-iframe(showinfo="0" width="90%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.COMO_BAIXAR" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")
          .video-span Como baixar

        .video-content
          iframe.default-iframe(showinfo="0" width="90%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.COMO_ENVIAR" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")
          .video-span Como enviar

      .video-container
        .video-content
          iframe.default-iframe(showinfo="0" width="90%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.MANUAL_USUARIO" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")
          .video-span Manual do usuário

        .video-content
          iframe.default-iframe(showinfo="0" width="90%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.MANUAL_USUARIO_OFF" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")
          .video-span Manual do usuário

    div(v-if="HOME_PAGE.COMO_FUNCIONA")
      el-col(:md="8" :sm="24")
        img.imagem-sicarf-como-funciona(
          :src="HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_1",
          :style="{'max-width': HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_1_HAS_WIDTH_E_HEIGHT_IGUAL ? '210px' : '305px', height: HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_1_HAS_WIDTH_E_HEIGHT_IGUAL ? '100%' : '80%'}"
        )
        p.padding.texto-veja-como-funciona(v-html="HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_1")
      el-col(:md="8" :sm="24")
        img.imagem-sicarf-como-funciona(
          :src="HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_2",
          :style="{'max-width': HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_2_HAS_WIDTH_E_HEIGHT_IGUAL ? '210px' : '305px', height: HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_2_HAS_WIDTH_E_HEIGHT_IGUAL ? '100%' : '80%'}"
        )
        p.padding.texto-veja-como-funciona(v-html="HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_2")
      el-col(:md="8" :sm="24")
        img.imagem-sicarf-como-funciona(
          :src="HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_3",
          :style="{'max-width': HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_3_HAS_WIDTH_E_HEIGHT_IGUAL ? '210px' : '305px', height: HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_IMAGEM_3_HAS_WIDTH_E_HEIGHT_IGUAL ? '100%' : '80%'}"
        )
        p.padding.texto-veja-como-funciona(v-html="HOME_PAGE.COMO_FUNCIONA.COMO_FUNCIONA_3")

  el-row.margin-bottom-container(v-if="HOME_PAGE.EXIBIR_GALERIA")
    the-gallery

  el-row.row-center.margin-bottom-container(v-if="HOME_PAGE.EXIBIR_COMENTARIOS")
    h1.titulo-sicarf Depoimentos sobre nós
    img.redimensiona(src="~@/assets/images/linha.png")
    the-comments

  el-row.row-center.margin-bottom-container
    div.padding-titulo
      h1.titulo-sicarf Entre em contato
      img.redimensiona(src="~@/assets/images/linha.png")
    div
      el-col(:md="HOME_PAGE.ENTRE_EM_CONTATO.EXIBIR_FORMULARIO ? 12 : 24" :sm="24" style="display: flex; align-items: center; flex-direction: column")
        div.padding-entrar-contato(:style="{width: HOME_PAGE.ENTRE_EM_CONTATO.EXIBIR_FORMULARIO ? '100%': '90%'}")
          div
            el-row
              span {{HOME_PAGE.ENTRE_EM_CONTATO.SOBRE}}
          br
          div.alinhamento-texto-entrar-contato(style="width: 100%")
            el-row(style="width: 100%" :class="!HOME_PAGE.ENTRE_EM_CONTATO.EXIBIR_FORMULARIO ? 'cards-sicarf' : ''")
              font-awesome-icon.icones-entrar-contato(icon="address-card")
              span {{HOME_PAGE.ENTRE_EM_CONTATO.ENDERECO}}
            br
            div(style="width: 100%;" :class="!HOME_PAGE.ENTRE_EM_CONTATO.EXIBIR_FORMULARIO ? 'row-divider-child' : ''")
              el-row
                font-awesome-icon.icones-entrar-contato(icon="building")
                span {{HOME_PAGE.ENTRE_EM_CONTATO.TELEFONE}}
              br
              div(v-if="HOME_PAGE.ENTRE_EM_CONTATO.SUPORTE")
                el-row
                  font-awesome-icon.icones-entrar-contato(icon="phone-square")
                  span {{HOME_PAGE.ENTRE_EM_CONTATO.SUPORTE}}
                br
              el-row
                font-awesome-icon.icones-entrar-contato(icon="globe-americas")
                span {{HOME_PAGE.ENTRE_EM_CONTATO.SITE}}
              div(v-if="HOME_PAGE.ENTRE_EM_CONTATO.HORARIO_FUNCIONAMENTO")
                br
                el-row
                  font-awesome-icon.icones-entrar-contato(icon="clock")
                  span {{HOME_PAGE.ENTRE_EM_CONTATO.HORARIO_FUNCIONAMENTO}}

      el-col.padding-entrar-contato.padding-botom-entrar-contato(:md="12" :sm="24", v-if="HOME_PAGE.ENTRE_EM_CONTATO.EXIBIR_FORMULARIO")
        validation-observer(ref='validation' tag='div').container-enviar-email
          el-col(:span="24")
            validation-provider(rules="required", v-slot="{ errors }")
              el-input.input.margin-top-input-nome(
                      :class="{'erro' : errors.length && !solicitacaoRealizada}"
                      name="nome",
                      v-model="contato.nome",
                      data-vv-scope="funcaoEmail",
                      placeholder='Nome',
                    )
              p.help.erro(v-if="!solicitacaoRealizada") {{ errors[0] }}
          el-col(:span="24")
            validation-provider(rules="required", v-slot="{ errors }")
              el-input.input(
                      :class="{'erro' : (errors.length && !solicitacaoRealizada) || !emailValido}"
                      name="email",
                      v-model="contato.email",
                      placeholder='Email',
                      data-vv-scope="funcaoEmail",
                      @change="isEmailValid"
                    )
              span.help.erro(v-if="!emailValido") Email inválido.
              p.help.erro(v-if="!solicitacaoRealizada") {{ errors[0] }}

          el-col(:span="24")
            validation-provider(rules="required", v-slot="{ errors }")
              el-input.input(
                      :class="{'erro' : errors.length && !solicitacaoRealizada}"
                      name="telefone",
                      v-mask="['(##) ####-####', '(##) #####-####']",
                      :maxlength=15,
                      v-model="contato.telefone",
                      data-vv-scope="funcaoEmail",
                      placeholder='Telefone',
                    )
              p.help.erro(v-if="!solicitacaoRealizada") {{ errors[0] }}

          el-col(:span="24")
            validation-provider(rules="required", v-slot="{ errors }")
              el-input.input(
                      :class="{'erro' : errors.length && !solicitacaoRealizada}"
                      type='textarea',
                      placeholder='Digite o texto...',
                      v-model='contato.texto'
                      name="texto",
                      data-vv-scope="funcaoEmail",
                      maxlength="500"
                    )
              p.help.erro(v-if="!solicitacaoRealizada") {{ errors[0] }}

          div.button
            el-button.btn(
              type="success",
              @click="enviarEmailEntrarEmContato()",
              :loading="loading"
            )
              span
                b Enviar &nbsp
                  font-awesome-icon(icon="paper-plane")
</template>

<script>
import TheDashboard from './TheDashboard'
import TheGallery from './TheGallery'
import TheComments from './TheComments'
import axios from '@/utils/api-axios'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapState, mapActions } from 'vuex'

export default {

  mixins: [
    AppNotificacao
  ],

  components: {
    TheDashboard,
    TheGallery,
    TheComments
  },
  data () {
    return {
      contato: {
        nome: null,
        email: null,
        telefone: null,
        texto: null
      },
      emailValido: true,
      solicitacaoRealizada: false,
      loading: false
    }
  },

  methods: {
    ...mapActions({
      downloadDocumentosAbertura: 'downloadPortal/downloadDocumentosAbertura',
      downloadAutoDeclaracao: 'downloadPortal/downloadAutoDeclaracao'
    }),
    async enviarEmailEntrarEmContato () {
      this.loading = true
      this.solicitacaoRealizada = false
      const result = await this.$refs.validation.validate()
      if (!result) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Para finalizar o envio do email preenche os campos.'
        )
        this.loading = false
        return
      }
      const response = await axios.post('publico/entrarEmContato', this.contato)
      if (response) {
        this.solicitacaoRealizada = true
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          response.data
        )
        this.contato = {
          nome: null,
          email: null,
          telefone: null,
          texto: null
        }
        this.loading = false
      }
    },
    isEmailValid () {
      if (!this.contato.email) {
        return
      }
      const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.emailValido = regex.test(this.contato.email)
    },
    handleTextoCadastro (e) {
      if (e.target.id === 'documentosNecessarios') {
        this.downloadDocumentosAbertura()
      }
    }
  },
  computed: {
    ...mapState({
      HOME_PAGE: state => state.userInterface.dadosEstado.PUBLICO.HOME_PAGE,
      VIDEOS_TUTORIAIS: state => state.userInterface.dadosEstado.PUBLICO.VIDEOS_TUTORIAIS,
      EXIBIR_COMO_BAIXAR: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_COMO_BAIXAR,
      EXIBIR_COMO_ENVIAR: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_COMO_ENVIAR,
      EXIBIR_CADASTRO_ONLINE: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_CADASTRO_ONLINE,
      EXIBIR_ACESSAR_ONLINE: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_ACESSAR_ONLINE
    }),
    isIcmBio () {
      return process.env.ESTADO === 'default'
    }
  }
}
</script>

<style lang="scss" scoped>
.cards-sicarf {
  display: flex;
  justify-content: center;
}

.line-height {
  line-height: 1.1;
}
.item-tipo-cadastro {
  margin-top: 0;
  font-size: 1em;
}
span.el-tooltip {
  font-size: 1em;
}
.margin-bottom-container {
  margin-bottom: 30px;
}
.alinhamento-texto-entrar-contato {
  text-align: left;
  padding-left: 15px;
  line-height: 1.4;
}
.primeiro-titulo-preto {
  font-size: 25px;
  color: black;
}
.icones-entrar-contato {
  margin-right: 5px;
  color: #009d64;
  font-size: 1.2em;
}
.padding-entrar-contato {
  padding: 30px;
}
.help.erro {
  text-align: initial;
}
.margin-top-input-nome {
  margin-bottom: 10px;
}
.padding-botom-entrar-contato {
  padding-bottom: 40px;
}
.container-enviar-email {
  background: #f9f5fa 0% 0% no-repeat padding-box;
  box-shadow: 0px 20px 10px #0000001f;
  border-radius: 26px;
  opacity: 1;
  width: 438px;
  padding: 20px;
  margin: 0 auto;
}
.padding-top-link-acesse {
  padding-top: 15px;
}
.padding-top-link-baixar-enviar {
  padding-top: 25px;
}
.links {
  text-decoration: none;
  color: #009d64;
  font-size: 35px;
  font-weight: bold;
}
.botao-aptidao{
  cursor: pointer;
}
.icone-colunas {
  padding-left: 10px;
}
.primeiro-titulo-segunda-coluna {
  margin-bottom: 5px;
}
.segundo-titulo-segunda-coluna {
  margin-top: 0;
  font-size: 25px;
  color: #009d64;
}
.como-fazer-seu-cadastro {
  width: 5.5em;
  padding-top: 30px;
}
.padding-top-cadastro {
  padding-top: 50px;
  padding-left: 22px;
  padding-right: 22px;
  line-height: 1.45em;
}
.padding-top-tipo-cadastro {
  padding-top: 35px;
  padding-left: 22px;
  padding-right: 22px;
}
.margin-negativo {
  margin-top: -160px;
}
.coluna-externa {
  color: #777373;
  height: 1280px;
  width: 307px;
  padding: 20px;
  background: white 0% 0% no-repeat padding-box;
  margin: 0 auto;
  border-radius: 14px;
  opacity: 3;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.coluna-externa-icmbio {
  color: #777373;
  height: 800px;
  width: 307px;
  padding: 20px;
  background: white 0% 0% no-repeat padding-box;
  margin: 0 auto;
  border-radius: 14px;
  opacity: 3;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.coluna-interna {
  text-align: center;
  width: 100%;
  height: 100%;
  border: 2px dashed #009d64;
  border-radius: 14px;
}
.quadrante-1 {
  text-align: center;
  width: 100%;
  height: 25%;
  border-bottom: 1.8px dashed #009d64;
}
.quadrante-2 {
  text-align: center;
  width: 100%;
  height: 61%;
  border-bottom: 1.8px dashed #009d64;
}
.quadrante-3 {
  text-align: center;
  width: 100%;
  height: 7%;
  border-bottom: 1.8px dashed #009d64;
}
.quadrante-4 {
  text-align: center;
  width: 100%;
  height: 7%;
}
.quadrante-5 {
  text-align: center;
  width: 100%;
  height: 67%;
  border-bottom: 1.8px dashed #009d64;
}
.quadrante-6 {
  text-align: center;
  width: 100%;
  height: 67%;
}
.coluna-center {
  margin-left: 50px;
  margin-right: 50px;
}
.padding-titulo {
  padding-bottom: 20px;
}
.redimensiona {
  width: 150px;
}
.button {
  text-align: right;
  padding: 5px 0px 5px 0;
}
.input {
  margin-bottom: 10px;
}
/deep/ .el-input__inner {
  background-color: #f9f5fa !important;
}
/deep/ .el-textarea__inner {
  background-color: #f9f5fa;
}
.padding {
  padding: 30px;
}
.texto-veja-como-funciona {
  font-size: 18px;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.row-center {
  text-align: center;
}
.sicarf {
  height: 100%;
  background: #fefbff 0% 0% no-repeat padding-box;
  opacity: 1;
}
.sicarf-col {
  height: 100%;
}
.the-sicarf {
  padding: 20px;
}
.sicarf.margin-bottom-container {
  display: flex;
  align-items: center;
}
.text-sicarf {
  margin: auto;
  text-align: justify;
  height: 100%;
  padding: 30px;
  img {
    text-align: center !important;
  }
  p {
    font-size: 1.1em;
    margin-top: 30px;
    color: #777373;
  }
  .descricaoSicarf {
    text-align: justify;
    text-justify: inter-word;
  }
}

.cabecalho {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.titulo-sicarf {
  color: black;
  font-weight: bold;
  font-size: 36px;
  margin-bottom: 2px;
}
.frame {
  white-space: nowrap;
  text-align: center;
}
.helper {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.image-sicarf {
  max-width: 570px;
  max-height: 445px;
  padding: 15px;
  vertical-align: middle;
}
.imagem-sicarf-como-funciona {
  width: 100%;
  height: 80%;
  max-width: 305px;
  max-height: 210px;
  padding: 15px;
}
.link-abas {
  cursor: pointer;
}
.titulo {
  color: #009f61;
  text-align: center;
}
.texto {
  padding: 0px 20px;
  align-self: center;
}
.image {
  display: block;
  width: 100%;
  float: left;
  max-width: 215px;
  max-height: 215px;
  padding: 15px;
}
a {
  color: #009f61;
  text-decoration: none;
}

@media screen and (max-width: 1300px) {
  .text-sicarf {
    p {
      margin-top: 20px;
    }
  }
  .image-sicarf {
    max-width: 440px;
  }
  .margin-negativo {
    margin-top: -110px;
  }
  .padding {
    padding: 0px;
  }
  .coluna-externa {
    width: 290px;
  }
  .padding-top-tipo-cadastro {
    padding-top: 20px;
  }
  .padding-top-cadastro {
    padding-top: 30px;
  }
}

@media screen and (max-width: 1600px) {
  .image {
    max-width: 300px;
    max-height: 300px;
  }
}

@media screen and (max-width: 991px) {
  .image {
    display: unset;
    position: relative;
    width: 150px;
    height: 150px;
    float: unset;
  }
  .sicarf {
    height: 100%;
  }

  .div-image {
    text-align: center;
  }
  .sicarf.margin-bottom-container {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
}

@media screen and (max-width: 500px) {
  .image-sicarf {
    max-width: 300px;
    max-height: 300px;
  }

  .container-enviar-email {
    width: 100%;
    padding: 20px;
  }
}

.video-container {
  display: flex;
  flex-direction: row;
  padding: 40px;
}

.video-span {
  color: #777373;
  font-weight: bold;
  padding-top: 10px;
}

.video-content {
  width: 50%;
}

@media only screen and (max-width: 1256px) {
  .video-content {
    width: 100%;
  }

  .video-container {
    flex-direction: column;
  }
}

.center {
  justify-content: center;
}

.row-divider-child {
  display: flex;
  justify-content: center;
}
.row-divider-child > *:not(:last-child) {
  padding-right: 10px;
  padding-left: 10px;
  border-right: 1px solid #CFCBCB;
  height: 25px;
}

.row-divider-child > *:last-child {
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/home/TheSicarf.vue